/**
 * 🤖 AI Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - refresh token 자동 갱신 지원
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

// AI API 베이스 URL - OpenAPI spec과 일치
const getAiApiBaseUrl = (): string => {
  return process.env.AI_API_BASE_URL || 'https://ai.ugot.uk/api/ai';
};

// AI 도메인용 커스텀 인스턴스 생성
// createOrvalCustomInstance를 사용하여 refresh token 자동 갱신 지원
export const customInstance = createOrvalCustomInstance(
  getAiApiBaseUrl(),
  {
    timeout: 120000, // 2분
    enableDebug: process.env.NODE_ENV === 'development',
    onAuthError: () => {
      console.warn('🤖 AI API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;